import { Outlet } from "@remix-run/react"
import Logo from "~/components/logo"

export default function AuthLayout() {
  return (
    <div>
      <main>
        <Outlet />
      </main>
    </div>
  )
}
